<template>
  <div class="task-box">
    <div class="task-header">
      <div class="task-status">{{ SEND_MSG_STATUS_MAP[item.status] }}</div>
      <div class="task-title">{{ item.title }}</div>
      <div class="task-date">{{ item.gmt_create }}</div>
    </div>
    <div class="task-content">
      <span v-if="getFinishDescList(item)">
        <span class="weight">{{ getFinishDescList(item)[0] || '' }}</span>
        {{ getFinishDescList(item)[1] || '' }}
      </span>
    </div>
    <div class="task-btn-group">
      <!-- 0:未发送 1:发送失败 2:已发送 -->
      <div
        class="task-btn"
        @click="onSendMsg(item)"
        v-if="item.wwx_user_id && item.status === 0 && isCurrentPeer(item)"
      >
        立即发送
      </div>
      <div
        class="task-btn"
        @click="onOpenChat(item)"
        v-if="item.wwx_user_id && !isCurrentPeer(item)"
      >
        打开会话
      </div>
    </div>
  </div>
</template>
<script>
import { SEND_MSG_STATUS_MAP } from '../../consts/workbench-const';
import '../less/CommonListItem.less';
import workWxService from '../../services/work-wx-service';
import toast from '@/services/toast.js';
import signReminderService from '../services/sign-reminder-service';

export default {
  props: {
    item: Object,
    unread: Number,
  },
  data() {
    return {
      SEND_MSG_STATUS_MAP,
    };
  },
  methods: {
    async onSendMsg(record) {
      const newWwxUserId = await this.validatorIsCurrentPeer(record);
      if (newWwxUserId !== record.wwx_user_id) {
        toast.show('无法找到对应联系人');
        this.$emit('success');
        return;
      }

      const { wxaUrl } = signReminderService.getSignReminderToWxaParams(record);
      console.error(wxaUrl, '单发链接');
      try {
        await signReminderService._sendChatMessage(
          '您有出签信息需要核对',
          wxaUrl,
        );
        await signReminderService.getMessageSignReminderStatus({
          applicant_sign_reminder_id_set: [record.applicant_sign_reminder_id],
          status: 2,
        });
        this.$emit('success');
      } catch (e) {
        toast.show('发送失败');
      }
    },
    // 校验操作用户是否一致
    validatorIsCurrentPeer(record) {
      return new Promise((resolve, reject) => {
        // 先检查当前用户是否一致，存在是否解绑换绑的情况
        signReminderService
          .checkApplicantSignReminder({
            user_account_id: record.user_account_id,
          })
          .then((res) => {
            resolve(res.wwx_user_id);
          })
          .catch((e) => {
            reject();
          });
      });
    },
    async onOpenChat(record) {
      const newWwxUserId = await this.validatorIsCurrentPeer(record);
      if (!newWwxUserId) {
        toast.show('无法找到对应联系人');
        this.$emit('success');
        return;
      }

      workWxService.workWxAgentConfig().then(() => {
        ww.openEnterpriseChat({
          // 注意：userIds和externalUserIds至少选填一个。内部群最多2000人；外部群最多500人；如果有微信联系人，最多40人
          externalUserIds: newWwxUserId || '',
          groupName: '', // 会话名称。单聊时该参数传入空字符串""即可。
          chatId: '', // 若要打开已有会话，需指定此参数。如果是新建会话，chatId必须为空串
          success() {},
          fail(e) {
            toast.show('无法找到对应联系人');
          },
        });
      });
    },
    // 是否为当前聊天同业
    isCurrentPeer(record) {
      // 展示：消息所属的同业ID与当前会话的同业ID不一致
      const currentUserId = localStorage.getItem('user_id');
      const belongToUserId = record.wwx_user_id;
      return belongToUserId === currentUserId;
    },
    // 获取同业名称和内容
    getFinishDescList(record) {
      if (!record.finish_desc) return;
      return record.finish_desc.split('<');
    },
  },
};
</script>

<style lang="less" scoped>
.weight {
  color: #fa3137;
}
</style>
